module.exports = __webpack_public_path__ + "files/2bc6eafbb42c6deb2dc00fd1e591bcc8.svg";